import { app } from '../../../../app';
import { Controller } from './session-recording-form.controller';

app.component('sessionRecordingForm', {
    bindings: {
        loginServicesConfiguration: '<',
        onChange: '&',
        onEnter: '&',
    },
    controller: Controller,
    templateUrl: require('./session-recording-form.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/session-recording/session-recording-form.component.js